<template>

      <newUser v-if='uid' :userID='uid' />
 
</template>

<script>
import newUser from "../components/myTasks/newUser"
import { postReq } from '../helper/firestore'
export default {
       components : {
        newUser
    },
    data() {
      return{
        uid : null
      }
    },
    mounted(){
      
            if(this.$route.params.type === "uid"){
              postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/patients/getPatientById',{uid:this.$route.params.value},result=>{

              })
            }else if (this.$route.params.type === "email"){

             postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/patients/getPatientByEmail',{email:this.$route.params.value},result=>{
                            
               this.uid = result.data[0].uid
              })
            }

       
    }
}
</script>

<style>

</style>